module.exports = __webpack_public_path__ + "img/NZA Annex A3 - Inputs catalog for EER modeling.xlsx";